import type {Maybe} from '@/types'

export enum ErrorCode {
  CHAT_AGENT_ERROR = 'CHAT_AGENT_ERROR',
  CONVERSATION_IN_USE = 'CONVERSATION_IN_USE',
  NOT_ENOUGH_CREDITS = 'NOT_ENOUGH_CREDITS',
  QUEUE_SEND_FAILED = 'QUEUE_SEND_FAILED',
  SEND_MESSAGE_FAILED = 'SEND_MESSAGE_FAILED',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  TOO_MANY_PENDING_CREDITS = 'TOO_MANY_PENDING_CREDITS',
  TOO_MANY_PENDING_MESSAGES = 'TOO_MANY_PENDING_MESSAGES',
}

export enum PaginationDirection {
  UP = 'UP',
  DOWN = 'DOWN',
}

export interface CursorResponse<TItem, TCursor = number> {
  items: TItem[]
  nextCursor: TCursor | null
  hasMore: boolean
}

export interface CursorRequest<TCursor = number> {
  cursor?: Maybe<TCursor>
  limit?: Maybe<number>
  direction?: PaginationDirection
}
